import React from "react";
import { Box, Grid, Paper, Typography, Button, useMediaQuery } from "@material-ui/core";
import { createStyles, makeStyles, Theme, useTheme } from "@material-ui/core/styles";

import PageContentWrap from "../../../components/Common/PageContentWrap";
import guestmeGatewayImage from "../../../images/guestme_gateway.png";
import OfferConfirmationModal from "./OfferConfirmationModal";


const useStyles = makeStyles((theme: Theme) => createStyles({
  paper: {
    backgroundColor: "rgba(70, 199, 188, 0.16)",
    border: "2px solid #6AE8C5",
    padding: theme.spacing(3),
    [theme.breakpoints.down(960)]: {
      padding: theme.spacing(2),
    },
  },
  headerRow: {
    display: "flex",
    flexDirection: "row",
    marginBottom: theme.spacing(3),
    alignItems: "flex-start",
  },
  iconWrap: {
    flexGrow: 0,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down(960)]: {
      flex: "0 0 30%",
      width: "30%",
      minWidth: "30%",
      marginRight: theme.spacing(2),
    },
  },
  iconImage: {
    display: "block",
    width: theme.spacing(12),
    height: theme.spacing(12),
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1),
    border: "1px solid #E7EBEE",
    background: '#F7F8FA',
    [theme.breakpoints.down(960)]: {
      width: "100%",
      height: "auto",
      padding: theme.spacing(2),
      aspectRatio: "1 / 1",
    },
  },
  content: {
    flex: "1 1 70%",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    paddingBottom: 4,
    marginTop: -theme.spacing(1),
  },
  infoRow: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down(960)]: {
      flexDirection: "column",
    },
  },
  infoText: {
    paddingRight: theme.spacing(3),
    width: "65%",
    [theme.breakpoints.down(960)]: {
      width: "100%",
      paddingRight: 0,
      paddingBottom: theme.spacing(2),
    },
  },
  priceBlock: {
    width: "35%",
    [theme.breakpoints.down(960)]: {
      width: "100%",
    },
  },
  priceTitle: {
    paddingBottom: theme.spacing(1),
    marginTop: -theme.spacing(1),
  },
  actionButton: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down(960)]: {
      width: "100%",
      minHeight: 48,
    },
  },
}));

/** @description Витрина подключения Guestme уведомлений */
export function GuestmeNotificationsShowcaseWidget({
  onEnable,
}: {
  onEnable: () => void,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(960));


  const [isOpenConfirmation, setIsOpenConfirmation] = React.useState(false);

  const openConfirmation = () => {
    setIsOpenConfirmation(true);
  };

  const closeConfirmation = () => {
    setIsOpenConfirmation(false);
  };

  const onAcceptOffer = () => {
    onEnable();
    closeConfirmation();
  }

  return (
    <PageContentWrap fullWidth spacing={0} noPadding={isMobile}>
      {isOpenConfirmation && (
        <OfferConfirmationModal
          handleClose={closeConfirmation}
          handleAccept={onAcceptOffer}
        />
      )}
      <Grid item xs={12}>
        <Paper elevation={3} className={classes.paper}>
          <Box className={classes.headerRow}>
            <Box className={classes.iconWrap}>
              <img
                src={guestmeGatewayImage}
                alt="Guestme"
                className={classes.iconImage}
              />
            </Box>
            <Box className={classes.content}>
              <Typography
                variant="h6"
                className={classes.title}
              >
                WhatsApp и Telegram уведомления
              </Typography>

              <Box className={classes.infoRow}>
                <Box className={classes.infoText}>
                  <Typography
                    variant="body1"
                    color="textSecondary"
                    style={{ paddingBottom: 16 }}
                  >
                    Работайте с&nbsp;гостями через мессенджеры&nbsp;&mdash;
                    без&nbsp;отдельных договоров, интеграций и&nbsp;лишних настроек.
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    Всё подключается и&nbsp;начинает работать буквально за&nbsp;пару минут!
                  </Typography>
                </Box>
                <Box className={classes.priceBlock}>
                  <Typography
                    variant="h4"
                    className={classes.priceTitle}
                  >
                    1500&nbsp;₽ / месяц
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    Без&nbsp;ограничения на&nbsp;количество уведомлений
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Button
            variant="contained"
            color="primary"
            className={classes.actionButton}
            onClick={openConfirmation}
          >
            Подключить&hellip;
          </Button>
        </Paper>
      </Grid>
    </PageContentWrap>
  );
}
